export default "__VITE_ASSET__CD42eueh__"